<template>
	<div class="checkout">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">			
			<top-nevleft></top-nevleft>
				
		 <b-col class="p-0">
		<order_details></order_details>
		
		<top-footer></top-footer>
		
		
		</b-col>
		</b-row>
		</b-container>
		
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
//import ProductSwiper from "@/components/product-swiper.vue";

import TreeviewPage from "@/components/agent/nevleft.vue";
import OrderDetails from "@/components/order_details.vue";
import '@/assets/checkout.scss';
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        "top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
		"order_details": OrderDetails,
	},
	mounted(){
       // this.initload();
        
	},
	data() {
		return{
           
		};
	},
	methods: {
		
		
	}
}
</script>

<style  lang="scss">

  
  .ivoiceTAle{
		.table td,.table th{
			border-top: 0px solid #dee2e6 !important;
		}
		.invoiceTitle{
			text-align:center !important;
			border-top: 1px solid #dee2e6 !important;
			border-bottom: 1px solid #dee2e6 !important;
		}
		.tblbr{
			border-right: 1px solid #dee2e6 !important;
		}
	}
	.collapsed{
		max-width: 100% !important;
	}
</style>